import { render, staticRenderFns } from "./settleModule.vue?vue&type=template&id=5ed38662&scoped=true"
import script from "./settleModule.vue?vue&type=script&lang=js"
export * from "./settleModule.vue?vue&type=script&lang=js"
import style0 from "./settleModule.vue?vue&type=style&index=0&id=5ed38662&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed38662",
  null
  
)

export default component.exports